export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const units = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log2(bytes) / 10);
  const size = bytes / (1 << (i * 10));
  return `${Number(size.toFixed(2))} ${units[i]}`;
};
